import Swiper from 'swiper/bundle';

/**
 * Initializes the reviews section carousel.
 * This function sets up a Swiper instance for the reviews section, 
 * configuring responsive breakpoints, space between slides, and a scrollbar.
 * 
 * @function reviewsSection
 * @returns {void} Returns nothing if the swiper container is not found.
 */
const reviewsSection = () => {
  const swiperReviewContainer = document.querySelector('.review-section .reviews-container__swiper');
  if (!swiperReviewContainer) return;

  new Swiper(swiperReviewContainer, {
    spaceBetween: 16,
    slidesPerView: 1.1,
    mousewheel: {
      forceToAxis: true,
    },
    scrollbar: {
      dragSize: 100,
      el: '.swiper-scrollbar',
    },
    slidesOffsetAfter: 16,
    breakpoints: {
      768: {
        slidesPerGroup: 2,
        slidesPerView: 2,
        spaceBetween: 16,
      },
      1024: {
        slidesPerGroup: 1,
        slidesPerView: 'auto',
        spaceBetween: 24,
        scrollbar: {
          dragSize: 150,
          el: '.swiper-scrollbar',
        },
      }
    }
  });
}

export default reviewsSection;